<template>
  <page-container
    primary
    title="Blog"
    intro=""
  >
    <v-row
      class="subheading"
    >
      <v-col
        v-if="!nonDraftBlogs.length"
        cols="12"
      >
        No blogs!
      </v-col>
      <v-col
        v-for="blog in nonDraftBlogs"
        v-else
        :key="blog.slug"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-card
          dark
          class="rounded-card"
          nuxt
          :to="localePath({name: 'blog-slug', params: {slug: blog.slug}})"
        >
          <v-img
            :src="blog.contents.attributes.image"
            aspect-ratio="1.5"
          >
            <v-row
              class="pt-2 fill-height d-flex flex-column"
              justify="space-between"
              no-gutters
            >
              <v-col
                class="pa-4 flex-grow-1"
                align-self="end"
              >
                <v-chip
                  color="teal"
                  label
                  text-color="white"
                >
                  <v-icon>mdi-calendar</v-icon>&nbsp;
                  <h4>{{ blog.publicationDate | prettyDate }}</h4>
                </v-chip>
              </v-col>
              <v-col
                class="bottom-gradient pa-4"
              >
                <h3 class="title">
                  {{ blog.contents.attributes.title }}
                </h3>
                <span>{{ blog.contents.attributes.summary }}</span>
              </v-col>
            </v-row>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import { getBreadcrumbSchema } from '@/assets/js/util'
import { format } from 'date-fns'
import { sortBy } from 'lodash'
import { fallbackDate } from '../../assets/js/util';

export default {
  components: {
    PageContainer
  },
  filters: {
    prettyDate(d) {
      return format(d, 'dd-MM-yyyy')
    }
  },
  async asyncData ({ app, params, store }) {
    const lang = app.i18n.locale
    const blogs = []
    for (const blog of store.state.content.blogs[lang]) {
      const blogData = {
        contents: await import(`../../content/blog/${lang}/${blog.slug}.md`),
        ...blog
      }
      // Check if publication date is set in the document.
      // Otherwise just show the creation moment.
      blogData.publicationDate = fallbackDate(blogData.contents.attributes.published, blogData.ctimeMs)
      blogs.push(blogData)
    }
    return { blogs }
  },
  computed: {
    language () {
      return this.$i18n.locale
    },
    nonDraftBlogs () {
      return sortBy(
        this.blogs.filter(blog => !blog.contents.attributes.draft),
        'publicationDate'
      ).reverse()
    }
  },
  head () {
    const title = 'Blog'
    return {
      title,
      script: [
        getBreadcrumbSchema(this.$route.path, title)
      ]
    }
  }
}
</script>

<style lang="stylus" scoped>
.bottom-gradient
  background-color: rgba(0,0,0,0.5)
</style>
